module.exports = __webpack_public_path__ + "media/images/brand/page_background/characters-dda23dc01daf49f1e83da6fb3009f274.svg";